import apiClient from './apiClient';
import { io } from 'socket.io-client';
import ENV from '../../config/env';

export const createStudentSession = async (examId, classExamId) => {
  const response = await apiClient.post('/student-camera-import/session', {
    examId,
    classExamId,
  });
  return response;
};

export const removeStudentImage = async (sessionId, imageUrl) => {
  const response = await apiClient.delete(`/student-camera-import/session/${sessionId}/image`, {
    data: { imageUrl }
  });
  return response;
};

export const endStudentSession = async (sessionId) => {
  const response = await apiClient.delete(`/student-camera-import/session/${sessionId}`);
  return response;
};

export const compileStudentSession = async (sessionId) => {
  const response = await apiClient.post(`/student-camera-import/session/${sessionId}/compile`);
  return response;
};

export const initiateCameraImportSocket = (sessionId, sessionToken, callbacks) => {
  const { onMobileConnected, onImageUploaded, onImageRemoved, onSessionEnded } = callbacks;

  let socketUrl = 'http://localhost:8081';
  if (ENV.API_URL) {
    try {
      const urlObj = new URL(ENV.API_URL);
      socketUrl = `${urlObj.protocol}//${urlObj.host}`;
    } catch (e) {
      socketUrl = ENV.API_URL.replace(/\/api\/v1\/web$/, '').replace(/\/api\/v1$/, '').replace(/\/api$/, '');
    }
  }

  const socket = io(`${socketUrl}/camera-import`, {
    transports: ['websocket'],
    forceNew: true,
    reconnection: true
  });

  socket.on('connect', () => {
    socket.emit('joinStudentSession', { sessionId, sessionToken }, (ack) => {
    });
  });

  socket.on('mobile_connected', () => {
    if (onMobileConnected) onMobileConnected();
  });

  socket.on('mobile_disconnected', () => {
    if (callbacks.onMobileDisconnected) callbacks.onMobileDisconnected();
  });

  socket.on('image_uploaded', (data) => {
    if (onImageUploaded) onImageUploaded(data);
  });

  socket.on('image_removed', (data) => {
    if (onImageRemoved) onImageRemoved(data);
  });

  socket.on('session_ended', () => {
    if (onSessionEnded) onSessionEnded();
  });

  socket.on('connect_error', (err) => {
    console.error('Camera import socket connection error:', err);
  });

  return socket;
};

export const cameraImportService = {
  createStudentSession,
  removeStudentImage,
  endStudentSession,
  compileStudentSession,
  initiateCameraImportSocket
};

export default cameraImportService;
